export default {
  buttons: {
    title1: 'Bijsnijden',
    title2: 'Sluiten',
  },
};
